import { render, staticRenderFns } from "./widget.vue.js?vue&type=template&id=1d896762!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./widget.vue?vue&type=template&id=1d896762"
import script from "./widget.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./widget.vue?vue&type=script&lang=js"
export * from "./widget.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports